<template>
  <div
    v-if="false"
    v-show="shouldShowGuideBtn"
    class="narrator-guide-btn"
    @mouseenter="onHover=true"
    @mouseleave="onHover=false"
  >
    <IButton
      id="IStagingTourGuideBtn"
      class="btn-ghost"
      @click="onTourGuideBtnClick"
    >
      <i
        v-if="onHover || isActive"
        class="isif isif-telephone-ringing"
      />
      <i
        v-else
        class="isif isif-telephone-fill"
      />
    </IButton>
    <ModalTourGuide
      ref="ModalTourGuide"
      @close="isActive=false"
      @showCalendar="$emit('showCalendar')"
    />
    <ModalWebRtcNotSupport ref="ModalWebRtcNotSupport" />
    <div
      class="narrator-guide-tip"
      :class="[onHover ? 'hover' : '']"
    >
      <span>{{ $t('GuidedTour') }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DetectRTC from 'detectrtc'
import IButton from '../../../IButton'
import ModalTourGuide from '../../modals/ModalTourGuide'
import ModalWebRtcNotSupport from '../../modals/ModalWebRtcNotSupport'

export default {
  name: 'IStagingTourGuideBtn',

  components: {
    IButton,
    ModalTourGuide,
    ModalWebRtcNotSupport
  },

  data () {
    return {
      onHover: false,
      isActive: false
    }
  },

  computed: {
    ...mapGetters([
      'visitorHasPass',
      'currentBuilding',
      'user'
    ]),

    ...mapGetters({
      isLogin: 'auth/isLogin'
    }),

    isInstantMessageActive () {
      if (!this.currentBuilding.instantMessagingEnable) return false
      if (this.isLogin && !this.currentBuilding.requireVisitorData) {
        return true
      }
      if (this.currentBuilding.requireVisitorData && this.visitorHasPass) {
        return true
      }
      return false
    },

    isGuideActive () {
      return this.currentBuilding.tourRingBtn
    },

    shouldShowGuideBtn () {
      if (this.isInstantMessageActive && this.isGuideActive) {
        return false // Business needs
      } else {
        return this.isGuideActive
      }
    }

  },

  methods: {
    onTourGuideBtnClick () {
      // VRViewer 頁面下，不需要判斷 In-app browser，
      // 下列任一條件成立時不開放使用 TourRing
      // 1. webRTC 不支援
      if (!DetectRTC.isWebRTCSupported) {
        this.$refs.ModalWebRtcNotSupport.show()
      } else {
        this.$refs.ModalTourGuide.show()
        this.isActive = true
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'

.narrator-guide-btn {
  position: relative;
  font-size: 1rem;
  cursor: pointer;
  margin-top : 16px;
  width: 40px;
  height: 40px;
  background-color: $el-success;
  border-radius: 50%;

  @media (min-width: $response) {
    width: 48px;
    height: 48px;
  }

  &, button {
    display: flex;
    align-items: center;
    color: white;
  }

  button {
    width: 100%;
    height: 100%;
    padding: 0;
    font-size: inherit;

    i {
      font-size: 1.5em;

      @media (min-width: $response) {
        font-size: 1.75em;
      }
    }
  }

  .narrator-guide-tip {
    position: absolute;
    right : 140%;
    top: 50%;
    opacity: 0;
    display: inline-block;
    white-space: nowrap;
    transform: translateY(-50%);
    line-height: 1.6
    transition: all .1s linear;
    pointer-events: none;

    &.hover {
      opacity: 1;
    }

    span {
      text-shadow: none;
      font-size: 0.9rem;
      padding: 4px;
      background-color: alpha($dark-gray, 80%);

      &::after {
        position: absolute;
        content: "";
        left: 100%;
        top: 0;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 12px;
        border-color: transparent transparent transparent alpha($dark-gray, 80%);
      }
    }
  }
}
</style>
